<template>
  <div>
    <vs-popup
      fullscreen
      :title="file.name"
      :active.sync="popupActivo"
    >
      <div v-if="file.type == 'pdf'">
        <iframe
          :src="file.source"
          class="w-full show-pdf"
          :style="{ height: 83 + 'vh' }"
        ></iframe>
      </div>
      <div v-else-if="file.type == 'xls' || file.type == 'xlsx'">
        <!-- <iframe
          :src="file.source"
          class="w-full show-pdf"
          :style="{ height: 83 + 'vh' }"
        ></iframe> -->
        GG
      </div>
      <div v-else>
        <vue-perfect-scrollbar class="scroll-area" :settings="settings">
          <img
            :src="file.source"
            alt="latest-upload"
            class="rounded mb-4 user-latest-image responsive"
          />
        </vue-perfect-scrollbar>
      </div>
    </vs-popup>
    <div class="vx-row">
      <div
        class="vx-col md:w-1/6 w-full mx-4"
        :key="i"
        v-for="(el, i) in data"
      >
        <vx-tooltip :text="el.name">
          <img
            v-if="el.file_type === 'xls' || el.file_type === 'xlsx'"
            src="@/assets/images/file-icons/jpg.png"
            class="rounded mb-4 user-latest-image responsive img-height"
            @click="open(el)"
          />
          <img
            v-else-if="el.file_type === 'pdf'"
            :src="getSrc(el.source)"
            class="rounded mb-4 user-latest-image responsive img-height"
            @click="open(el)"
          />
          <img
            v-else
            :src="getSrc(el.source)"
            class="rounded mb-4 user-latest-image responsive img-height"
            @click="open(el)"
          />
        </vx-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from '@/urls.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {
    VuePerfectScrollbar,
  },
  data: () => ({
    popupActivo: false,
    settings: {
      maxScrollbarLength: 60,
    },
    file: {
      name: '',
      source: '',
      type: '',
    },
  }),
  methods: {
    open(data) {
      this.file.name = data.name
      this.file.source = BASE_URL + 'storage/' + data.source
      this.file.type = data.file_type
      this.popupActivo = true
    },
    getSrc(source){
      return BASE_URL + 'storage/' + source
    }
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
/* 1366 x 768 */
.show-pdf {
  display: block;
  border: none;
}


.scroll-hiden {
  .vs-popup--content {
    overflow: hidden;
  }
}
</style>
